import * as actionTypes from './actionTypes';

export const mapSexualOrientationNextStep = () => {
  return {
    type : actionTypes.MAP_SEXUAL_ORIENTATION_NEXT_STEP,
    val : null
  }
}

export const mapSexualOrientationGoBack = () => {
  return {
    type : actionTypes.MAP_SEXUAL_ORIENTATION_PREVIOUS_STEP,
    val : null
  }
}

export const mapSexualOrientationUploadFileSuccess = (columns, data, file) => {
  console.log(columns, data, file)
  return {
    type : actionTypes.MAP_SEXUAL_ORIENTATION_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapSexualOrientationMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_SEXUAL_ORIENTATION_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllSexualOrientationMapping = (val) => {
  return {
    type : actionTypes.MAP_SEXUAL_ORIENTATION_SAVE_SEXUAL_ORIENTATION_MAPPING,
    val : val
  }
}

export const resetSexualOrientation = () => {
  return {
    type : actionTypes.MAP_SEXUAL_ORIENTATION_RESET,
    val : null
  }
}

export const resetMapSexualOrientationStep = () => {
  return {
    type : actionTypes.MAP_SEXUAL_ORIENTATION_RESET_STEP,
    val : null
  }
}
